module.exports = __webpack_public_path__ + "static/media/flashgbs-5.ca8adaa6.jpg";